import * as React from 'react';

import { HStack, VStack } from '@rbilabs/universal-components';

import { useRoute } from 'hooks/navigation/use-route';
import { routes } from 'utils/routing';

import { StoreOrderButton } from '..';

import { StoreCardActions, StoreCardDetails } from './components';
import { Container, Distance, disableColorProp } from './store-card.styled';
import { StoreCardViewProps } from './types';

export const StoreCardView: React.FC<StoreCardViewProps> = ({
  isFavorite = false,
  isUpdatingFavorites = false,
  onCardPress,
  onDiagnosticsClick,
  onFavoriteClick,
  onOrderPress,
  onInfoPress,
  storeDetails,
  errorMessage,
  isInMapView,
  isInSupportForm,
  restaurantCanBeSelected,
  isSelected,
}) => {
  const { address, distanceText, restaurant, isActive } = storeDetails;
  const { pathname } = useRoute();
  const isFavoriteSearch = pathname === routes.signUp;

  return (
    <Container isActive={isActive} onPress={onCardPress} accessible={false}>
      <HStack>
        <StoreCardDetails
          onInfoPress={onInfoPress}
          errorMessage={errorMessage}
          storeDetails={storeDetails}
          isSelected={isSelected}
        />
        <VStack justifyContent="space-between">
          <StoreCardActions
            dd-action-name={`${address} ${isFavorite ? 'unfavorite' : 'favorite'}`}
            isFavorite={isFavorite}
            onDiagnosticsClick={!isFavoriteSearch ? onDiagnosticsClick : undefined}
            onFavoritesClick={!isFavoriteSearch ? onFavoriteClick : onCardPress}
            isUpdatingFavorites={isUpdatingFavorites}
          />
          <Distance {...(!isActive && disableColorProp)}>{distanceText}</Distance>
        </VStack>
      </HStack>
      {(isSelected || isInMapView) && restaurantCanBeSelected && (
        <StoreOrderButton
          isInSupportForm={isInSupportForm}
          onOrderPress={onOrderPress}
          restaurant={restaurant}
          restaurantCanBeSelected={restaurantCanBeSelected}
        />
      )}
    </Container>
  );
};
